import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/Footer';
import Hero from './Hero';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
  },
  rootDesktop: {
    height: '100vh',
  },
  rootMobile: {
    justifyContent: 'center',
  },
  formWrapper: {
    width: '100%',
  },
  formWrapperMobile: {
    maxWidth: theme.dimensions.md,
    width: '100%',
  },
  formWrapperDesktop: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(0, 8),
    maxWidth: theme.dimensions.lg,
    width: '100%',
  },
  hero: {},
  footer: {
    width: 'inherit',
  },
});

const Unauthenticated = ({
  className,
  classes,
  children,
  test,
}) => {
  const isMobile = useMobileLayout();

  return (
    <Box
      test={test}
      className={classNames(classes.root, className, {
        [classes.rootMobile]: isMobile,
        [classes.rootDesktop]: !isMobile,
      })}
    >
      <div
        className={classNames(classes.formWrapper, {
          [classes.formWrapperMobile]: isMobile,
          [classes.formWrapperDesktop]: !isMobile,
        })}
      >
        {children}
        <Footer />
      </div>
      {!isMobile && <Hero className={classes.hero} />}
    </Box>
  );
};

Unauthenticated.defaultProps = {
  className: '',
  test: null,
};

Unauthenticated.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(Unauthenticated);
